"use strict";
(self["webpackChunkowow_shopify_theme"] = self["webpackChunkowow_shopify_theme"] || []).push([[3385],{

/***/ 3385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ i_spinner; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/vue@3.4.32/node_modules/vue/dist/vue.esm-bundler.js + 6 modules
var vue_esm_bundler = __webpack_require__(1142);
;// CONCATENATED MODULE: ./node_modules/.pnpm/babel-loader@9.1.3_@babel+core@7.24.0_webpack@5.90.3/node_modules/babel-loader/lib/index.js??clonedRuleSet-6!./node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.21_vue@3.4.32_webpack@5.90.3/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.21_vue@3.4.32_webpack@5.90.3/node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/vue/components/icons/i-spinner.vue?vue&type=template&id=6b5fa4ab

var _hoisted_1 = /*#__PURE__*/(0,vue_esm_bundler/* createElementVNode */.Lk)("circle", {
  "class": "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1);
var _hoisted_2 = /*#__PURE__*/(0,vue_esm_bundler/* createElementVNode */.Lk)("path", {
  "class": "opacity-75",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
  fill: "currentColor"
}, null, -1);
var _hoisted_3 = [_hoisted_1, _hoisted_2];
function render(_ctx, _cache) {
  return (0,vue_esm_bundler/* openBlock */.uX)(), (0,vue_esm_bundler/* createElementBlock */.CE)("svg", {
    "class": (0,vue_esm_bundler/* normalizeClass */.C4)(_ctx.$attrs["class"] || 'w-6 h-6'),
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 2);
}
;// CONCATENATED MODULE: ./src/vue/components/icons/i-spinner.vue?vue&type=template&id=6b5fa4ab

// EXTERNAL MODULE: ./node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.21_vue@3.4.32_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3650);
;// CONCATENATED MODULE: ./src/vue/components/icons/i-spinner.vue

const script = {}

;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.A)(script, [['render',render]])

/* harmony default export */ var i_spinner = (__exports__);

/***/ })

}]);